module.exports = __webpack_public_path__ + "front/img/7.6ccd705e.png";